<div *ngIf="activatedOffer || params['rewards'] === '1'" class="offer-tag">
  <div *ngIf="offerpriority" class="tag">
    <mat-icon>star</mat-icon><app-currency-icon [currency]="'INR'"></app-currency-icon>{{activatedOffer}} OFFER APPLIED!
  </div>
  <div *ngIf="params['rewards'] === '1' && !offerpriority" class="tag">
    <mat-icon>star</mat-icon> REWARDS & BENEFITS APPLIED
  </div>
  <div class="triangle-left"></div>
</div>